<footer class="fixed bottom-0 w-full z-50" [ngClass]="{'max-w-[1440px] mx-auto': !isLoginErrorRoute}">
    <div class="px-6 py-1.5 flex justify-end items-center gap-9 bg-background-dark-00">
        <div>
            <img src="{{ environment.publicUrl }}/assets/icons/brands/silestone.svg" alt="Silestone" />
        </div>
        <div>
            <img src="{{ environment.publicUrl }}/assets/icons/brands/dekton.svg" alt="Dekton" />
        </div>
        <div>
            <img src="{{ environment.publicUrl }}/assets/icons/brands/eclos.svg" alt="Eclos" />
        </div>
        <div>
            <img src="{{ environment.publicUrl }}/assets/icons/brands/sensa.svg" alt="Sensa" />
        </div>
        <div>
            <img src="{{ environment.publicUrl }}/assets/icons/brands/scalea.svg" alt="Scalea" />
        </div>
        
    </div>
</footer>
